import http from "plugins/axios";

export default {
  getUserList({
    page, size,userId,channelAccount, userAccount,channelUserId, type,
  }) {
    return http.get({
      url: `/ta/admin/channel/getChannelNextList?page=${page}&size=${size}&userId=${userId}&channelUserId=${channelUserId}&channelAccount=${channelAccount}&userAccount=${userAccount}&type=${type}`,
    });
  },

  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    });
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate, spotRate }) {
    const params = [
      `channelId=${channelId}`,
      `userId=${userId}`,
      `rate=${rate}`,
    ];
    if (spotRate !== undefined && spotRate !== "" && spotRate !== null) {
      params.push(`spotRate=${spotRate}`);
    }
    return http.post({
      url: `/channel/partner/rebateRate?${params.join("&")}`,
    });
  },


  channelUserLevelList(data) {
    return http.post({
      url: `/ta/admin/channel/channelUserLevelList`,
      data
    });
  },
};
